import { ApiPrefixInterceptor } from '$core/interceptors/api-prefix.interceptor';
import { HeaderInterceptor } from '$core/interceptors/headers.interceptor';
import { ErrorsHandlerService } from '$core/services/errors-handler.service';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { ShellModule } from './shell/shell.module';

@NgModule({
  imports: [CommonModule, ShellModule],
  exports: [ShellModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ErrorsHandlerService,
    },
  ],
})
export class CoreModule {}
